import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_LOGIN } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";
import { toast } from "../../components/toast";
import { sessionService } from "../../services/sessionService";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const postLogin = createAsyncThunk(
  ACTIONS_LOGIN.post_login,
  async (payload) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.login,
        payload,
      );

      const message = getLocalizedMessage(response, i18n);
      toast.success(message);

      // Set session start time for background refresh monitoring
      sessionService.setSessionStartTime();

      return response.data;
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      console.error("Login Error:", error);
      throw error;
    }
  },
);

// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { ACTIONS_LOGIN } from "../../action-types/actions";
// import { APP_PATH } from "../../api/backendPath";
// import axios from "axios";
// import { toast } from '../../components/toast'
// export const postLogin = createAsyncThunk(
//   ACTIONS_LOGIN.post_login,
//   async ({ payload, navigate }, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}${APP_PATH.login}`,
//         payload
//       );
//       const { status, status_code, data, message } = response.data;
//       if (status && status_code === 200) {
//         const { access_token, refresh_token, verification_status, user } = data;
//         // ✅ Save login tokens & user info
//         sessionStorage.setItem("usr_1a2b3c", access_token);
//         sessionStorage.setItem("usr_4d5e6f", refresh_token);
//         sessionStorage.setItem("usr_status", verification_status);
//         sessionStorage.setItem("usr_role", user.role_id);
//         sessionStorage.setItem("usr_name", user.name);

//         // ✅ Handle verification status-based access
//         switch (verification_status) {
//           case "APPROVED":
//             toast.success("Welcome! Access granted.");
//             navigate("/dashboard");
//             break;
//           case "PENDING":
//             toast.info("Your documents are under verification. Limited access granted.");
//             navigate("/verification-pending");
//             break;
//           case "NOT_UPLOADED":
//             toast.warning("Please upload your documents to proceed.");
//             navigate("/upload-documents");
//             break;
//           case "REJECTED":
//             toast.error("Your documents were rejected. Please re-upload to continue.");
//             navigate("/reupload-documents");
//             break;

//           default:
//             toast.error("Unknown verification status. Contact support.");
//             navigate("/support");
//             break;
//         }

//         return data;
//       } else {
//         // ❌ Handle known error responses
//         if (response.data.status_code === 401) {
//           toast.error(message?.detail || "Unauthorized access.");
//         } else if (response.data.status_code === 500) {
//           const msg =
//             message?.non_field_errors?.[0] ||
//             message?.email?.[0] ||
//             message?.password?.[0] ||
//             "Server error. Please try again later.";
//           toast.error(msg);
//         } else {
//           toast.error("Login failed. Please try again.");
//         }
//         return rejectWithValue(response.data);
//       }
//     } catch (error) {
//       console.error("Login Error:", error);
//       toast.error(
//         error?.response?.data?.message ||
//           "Something went wrong. Please try again later."
//       );
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );
